class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    this.updateHeaderOffset();
    this.onResizeOffset = this.onResizeOffset || this.updateHeaderOffset.bind(this);
    window.addEventListener('resize', this.onResizeOffset);
    window.addEventListener('scroll', this.onResizeOffset, { passive: true });

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  updateHeaderOffset() {
    const header = document.querySelector('.section-header');
    const announcement = document.querySelector('.shopify-section-group-header-group .announcement-bar-section, .announcement-bar-section');
    let bottom = 0;
    if (announcement) {
      const rect = announcement.getBoundingClientRect();
      bottom = Math.max(bottom, rect.bottom);
    }
    if (header) {
      const rect = header.getBoundingClientRect();
      bottom = Math.max(bottom, rect.bottom);
    }
    bottom = Math.max(0, Math.round(bottom));
    document.documentElement.style.setProperty('--header-bottom-position', `${bottom}px`);
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
    if (this.onResizeOffset) {
      window.removeEventListener('resize', this.onResizeOffset);
      window.removeEventListener('scroll', this.onResizeOffset);
    }
  }
}

customElements.define('details-modal', DetailsModal);
